import {useTranslation} from 'react-i18next';
import {useFormContext} from 'react-hook-form';
import {PATTERNS} from '@chekin/core';
import {InputController as Input} from '@guestapp/old-ui-kit';
import {StyledFormFieldWrapper} from './styled';

interface EmailInputProps {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
}

const EmailInput = ({
  name,
  label,
  disabled = false,
  required = false,
}: EmailInputProps) => {
  const {t} = useTranslation();
  const {
    register,
    control,
    formState: {errors},
  } = useFormContext();

  return (
    <StyledFormFieldWrapper>
      <Input
        label={label}
        {...register(name, {
          required: required ? t('email_required') : false,
          pattern: {
            value: PATTERNS.email,
            message: t('invalid_email'),
          },
        })}
        control={control}
        inputMode="email"
        autoCorrect="off"
        spellCheck={false}
        autoCapitalize="none"
        error={errors[name]?.message as string}
        disabled={disabled}
      />
    </StyledFormFieldWrapper>
  );
};

export {EmailInput};
